import { Component, OnInit } from '@angular/core';
import {DataService} from '../../../../../../services/commande-client/data.service';

@Component({
  selector: 'app-annule-bon-sortie',
  templateUrl: './annule-bon-sortie.component.html',
  styleUrls: ['./annule-bon-sortie.component.scss']
})
export class AnnuleBonSortieComponent implements OnInit {

    constructor(private dataService: DataService) {}

    ngOnInit(): void {
        this.dataService.filterOrdersByStatus('Tous');
    }

}
